// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ProjectRoleDetailsFragmentDoc, TaskFilterOptionsFragmentDoc, ScheduleDetailsFragmentDoc } from '../../../fragments/circularFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ScheduleTemplatesPageMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ScheduleTemplatesPageMetadataQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type ScheduleTemplateMetadataQueryVariables = Types.Exact<{
  scheduleTemplateId: Types.Scalars['ID']['input'];
  stage: Types.Stage;
}>;


export type ScheduleTemplateMetadataQuery = { __typename?: 'Query', schedules: Array<{ __typename?: 'Schedule', id: string, duration?: number | null | undefined, interval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined, baselineInterval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined, scheduleSetting?: { __typename?: 'ScheduleSetting', id: string, exceptions?: any | null | undefined, workingDays: Array<Types.DayOfWeek> } | null | undefined }>, scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string }> };

export type ScheduleTemplatesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ScheduleTemplatesFilter>;
}>;


export type ScheduleTemplatesQuery = { __typename?: 'Query', scheduleTemplates: Array<{ __typename?: 'ScheduleTemplate', id: string, name: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], status: Types.ScheduleTemplateStatus, stage: Types.Stage, schedules: Array<{ __typename?: 'Schedule', id: string, updatedAt: Types.Scalars['DateTime']['input'] }>, statusDetail: { __typename?: 'ScheduleTemplateStatusDetail', name: string, code: Types.ScheduleTemplateStatus }, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, developments: Array<{ __typename?: 'Development', id: string, name: string }> }> };

export type ScheduleTemplateDetailQueryVariables = Types.Exact<{
  scheduleTemplateId: Types.Scalars['ID']['input'];
}>;


export type ScheduleTemplateDetailQuery = { __typename?: 'Query', scheduleTemplate: { __typename?: 'ScheduleTemplate', id: string, name: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], status: Types.ScheduleTemplateStatus, stage: Types.Stage, schedules: Array<{ __typename?: 'Schedule', id: string, updatedAt: Types.Scalars['DateTime']['input'] }>, statusDetail: { __typename?: 'ScheduleTemplateStatusDetail', name: string, code: Types.ScheduleTemplateStatus }, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, developments: Array<{ __typename?: 'Development', id: string, name: string }> } };

export type ScheduleTemplateEditPageQueryVariables = Types.Exact<{
  scheduleTemplateId: Types.Scalars['ID']['input'];
}>;


export type ScheduleTemplateEditPageQuery = { __typename?: 'Query', scheduleTemplate: { __typename?: 'ScheduleTemplate', id: string, name: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], status: Types.ScheduleTemplateStatus, stage: Types.Stage, schedules: Array<{ __typename?: 'Schedule', id: string, updatedAt: Types.Scalars['DateTime']['input'] }>, statusDetail: { __typename?: 'ScheduleTemplateStatusDetail', name: string, code: Types.ScheduleTemplateStatus }, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, developments: Array<{ __typename?: 'Development', id: string, name: string }> }, schedules: Array<{ __typename?: 'Schedule', id: string, stage: Types.Stage, status: Types.ScheduleStatus, isLocked: boolean, parent:
      | { __typename?: 'StandaloneProject', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> }
      | { __typename?: 'Region', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> }
      | { __typename?: 'Development', id: string, teamMembers: Array<{ __typename?: 'DevelopmentTeamMember', id: string, internalUser: { __typename?: 'InternalUser', id: string, name: string, avatar: string } }> }
      | { __typename?: 'Market', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> }
      | { __typename?: 'Community', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> }
      | { __typename?: 'Subdivision', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> }
      | { __typename?: 'Lot', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> }
      | { __typename?: 'Structure', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> }
      | { __typename?: 'Unit', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> }
      | { __typename?: 'ScheduleTemplate', id: string }
    , market?: { __typename?: 'Market', id: string } | null | undefined, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string }, statusDetail: { __typename?: 'ScheduleStatusDetail', code: Types.ScheduleStatus, name: string }, interval?: { __typename?: 'CalendarInterval', calendarProgress: number, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined, baselineInterval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined, scheduleSetting?: { __typename?: 'ScheduleSetting', id: string, workingDays: Array<Types.DayOfWeek>, exceptions?: any | null | undefined } | null | undefined, canPublishSchedule: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canCompleteSchedule: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string, assignee?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string, enableClickToPay: boolean } | null | undefined, projectItems: Array<{ __typename?: 'ProjectItem', id: string }> }>, projectRoleDetails: Array<{ __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }> };

export type SaveScheduleTemplatesMutationVariables = Types.Exact<{
  scheduleTemplates: Types.SaveScheduleTemplatesInput;
}>;


export type SaveScheduleTemplatesMutation = { __typename?: 'Mutation', saveScheduleTemplates: { __typename?: 'SaveScheduleTemplatesResult', scheduleTemplates: Array<{ __typename?: 'ScheduleTemplate', id: string, name: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], status: Types.ScheduleTemplateStatus, stage: Types.Stage, schedules: Array<{ __typename?: 'Schedule', id: string, updatedAt: Types.Scalars['DateTime']['input'] }>, statusDetail: { __typename?: 'ScheduleTemplateStatusDetail', name: string, code: Types.ScheduleTemplateStatus }, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, developments: Array<{ __typename?: 'Development', id: string, name: string }> }>, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null | undefined } };

export type DuplicateScheduleTemplateMutationVariables = Types.Exact<{
  input: Types.DuplicateScheduleTemplateInput;
}>;


export type DuplicateScheduleTemplateMutation = { __typename?: 'Mutation', duplicateScheduleTemplate: { __typename?: 'DuplicateScheduleTemplateResult', scheduleTemplate?: { __typename?: 'ScheduleTemplate', id: string, name: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], status: Types.ScheduleTemplateStatus, stage: Types.Stage, schedules: Array<{ __typename?: 'Schedule', id: string, updatedAt: Types.Scalars['DateTime']['input'] }>, statusDetail: { __typename?: 'ScheduleTemplateStatusDetail', name: string, code: Types.ScheduleTemplateStatus }, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, developments: Array<{ __typename?: 'Development', id: string, name: string }> } | null | undefined, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null | undefined } };

export type ScheduleTemplatesDetailFragment = { __typename?: 'ScheduleTemplate', id: string, name: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], status: Types.ScheduleTemplateStatus, stage: Types.Stage, schedules: Array<{ __typename?: 'Schedule', id: string, updatedAt: Types.Scalars['DateTime']['input'] }>, statusDetail: { __typename?: 'ScheduleTemplateStatusDetail', name: string, code: Types.ScheduleTemplateStatus }, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, developments: Array<{ __typename?: 'Development', id: string, name: string }> };

export const ScheduleTemplatesDetailFragmentDoc = gql`
    fragment ScheduleTemplatesDetail on ScheduleTemplate {
  id
  name
  createdAt
  updatedAt
  status
  stage
  schedules {
    id
    updatedAt
  }
  statusDetail {
    name
    code
  }
  market {
    id
    name
  }
  developments {
    id
    name
  }
}
    `;
export const ScheduleTemplatesPageMetadataDocument = gql`
    query ScheduleTemplatesPageMetadata {
  markets {
    id
    name
  }
}
    `;

/**
 * __useScheduleTemplatesPageMetadataQuery__
 *
 * To run a query within a React component, call `useScheduleTemplatesPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTemplatesPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTemplatesPageMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduleTemplatesPageMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>(ScheduleTemplatesPageMetadataDocument, options);
      }
export function useScheduleTemplatesPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>(ScheduleTemplatesPageMetadataDocument, options);
        }
// @ts-ignore
export function useScheduleTemplatesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>;
export function useScheduleTemplatesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplatesPageMetadataQuery | undefined, ScheduleTemplatesPageMetadataQueryVariables>;
export function useScheduleTemplatesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>(ScheduleTemplatesPageMetadataDocument, options);
        }
export type ScheduleTemplatesPageMetadataQueryHookResult = ReturnType<typeof useScheduleTemplatesPageMetadataQuery>;
export type ScheduleTemplatesPageMetadataLazyQueryHookResult = ReturnType<typeof useScheduleTemplatesPageMetadataLazyQuery>;
export type ScheduleTemplatesPageMetadataSuspenseQueryHookResult = ReturnType<typeof useScheduleTemplatesPageMetadataSuspenseQuery>;
export type ScheduleTemplatesPageMetadataQueryResult = ApolloReactCommon.QueryResult<ScheduleTemplatesPageMetadataQuery, ScheduleTemplatesPageMetadataQueryVariables>;
export const ScheduleTemplateMetadataDocument = gql`
    query ScheduleTemplateMetadata($scheduleTemplateId: ID!, $stage: Stage!) {
  schedules(filter: {parent: [$scheduleTemplateId], stage: [$stage]}) {
    id
    duration
    interval {
      startDate
      durationInDays
    }
    baselineInterval {
      startDate
      durationInDays
    }
    scheduleSetting {
      id
      exceptions
      workingDays
    }
  }
  scheduleTasks(
    filter: {scheduleParent: [$scheduleTemplateId], stage: [$stage]}
    first: 10000
  ) {
    id
  }
}
    `;

/**
 * __useScheduleTemplateMetadataQuery__
 *
 * To run a query within a React component, call `useScheduleTemplateMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTemplateMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTemplateMetadataQuery({
 *   variables: {
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useScheduleTemplateMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables> & ({ variables: ScheduleTemplateMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>(ScheduleTemplateMetadataDocument, options);
      }
export function useScheduleTemplateMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>(ScheduleTemplateMetadataDocument, options);
        }
// @ts-ignore
export function useScheduleTemplateMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>;
export function useScheduleTemplateMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplateMetadataQuery | undefined, ScheduleTemplateMetadataQueryVariables>;
export function useScheduleTemplateMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>(ScheduleTemplateMetadataDocument, options);
        }
export type ScheduleTemplateMetadataQueryHookResult = ReturnType<typeof useScheduleTemplateMetadataQuery>;
export type ScheduleTemplateMetadataLazyQueryHookResult = ReturnType<typeof useScheduleTemplateMetadataLazyQuery>;
export type ScheduleTemplateMetadataSuspenseQueryHookResult = ReturnType<typeof useScheduleTemplateMetadataSuspenseQuery>;
export type ScheduleTemplateMetadataQueryResult = ApolloReactCommon.QueryResult<ScheduleTemplateMetadataQuery, ScheduleTemplateMetadataQueryVariables>;
export const ScheduleTemplatesDocument = gql`
    query ScheduleTemplates($filter: ScheduleTemplatesFilter) {
  scheduleTemplates(filter: $filter) {
    ...ScheduleTemplatesDetail
  }
}
    ${ScheduleTemplatesDetailFragmentDoc}`;

/**
 * __useScheduleTemplatesQuery__
 *
 * To run a query within a React component, call `useScheduleTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScheduleTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>(ScheduleTemplatesDocument, options);
      }
export function useScheduleTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>(ScheduleTemplatesDocument, options);
        }
// @ts-ignore
export function useScheduleTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>;
export function useScheduleTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplatesQuery | undefined, ScheduleTemplatesQueryVariables>;
export function useScheduleTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>(ScheduleTemplatesDocument, options);
        }
export type ScheduleTemplatesQueryHookResult = ReturnType<typeof useScheduleTemplatesQuery>;
export type ScheduleTemplatesLazyQueryHookResult = ReturnType<typeof useScheduleTemplatesLazyQuery>;
export type ScheduleTemplatesSuspenseQueryHookResult = ReturnType<typeof useScheduleTemplatesSuspenseQuery>;
export type ScheduleTemplatesQueryResult = ApolloReactCommon.QueryResult<ScheduleTemplatesQuery, ScheduleTemplatesQueryVariables>;
export const ScheduleTemplateDetailDocument = gql`
    query ScheduleTemplateDetail($scheduleTemplateId: ID!) {
  scheduleTemplate(id: $scheduleTemplateId) {
    ...ScheduleTemplatesDetail
  }
}
    ${ScheduleTemplatesDetailFragmentDoc}`;

/**
 * __useScheduleTemplateDetailQuery__
 *
 * To run a query within a React component, call `useScheduleTemplateDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTemplateDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTemplateDetailQuery({
 *   variables: {
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *   },
 * });
 */
export function useScheduleTemplateDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables> & ({ variables: ScheduleTemplateDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>(ScheduleTemplateDetailDocument, options);
      }
export function useScheduleTemplateDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>(ScheduleTemplateDetailDocument, options);
        }
// @ts-ignore
export function useScheduleTemplateDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>;
export function useScheduleTemplateDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplateDetailQuery | undefined, ScheduleTemplateDetailQueryVariables>;
export function useScheduleTemplateDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>(ScheduleTemplateDetailDocument, options);
        }
export type ScheduleTemplateDetailQueryHookResult = ReturnType<typeof useScheduleTemplateDetailQuery>;
export type ScheduleTemplateDetailLazyQueryHookResult = ReturnType<typeof useScheduleTemplateDetailLazyQuery>;
export type ScheduleTemplateDetailSuspenseQueryHookResult = ReturnType<typeof useScheduleTemplateDetailSuspenseQuery>;
export type ScheduleTemplateDetailQueryResult = ApolloReactCommon.QueryResult<ScheduleTemplateDetailQuery, ScheduleTemplateDetailQueryVariables>;
export const ScheduleTemplateEditPageDocument = gql`
    query ScheduleTemplateEditPage($scheduleTemplateId: ID!) {
  scheduleTemplate(id: $scheduleTemplateId) {
    ...ScheduleTemplatesDetail
  }
  schedules(filter: {parent: [$scheduleTemplateId]}) {
    ...ScheduleDetails
  }
  scheduleTasks(filter: {scheduleParent: [$scheduleTemplateId]}, first: 10000) {
    ...TaskFilterOptions
  }
  projectRoleDetails {
    ...ProjectRoleDetails
  }
}
    ${ScheduleTemplatesDetailFragmentDoc}
${ScheduleDetailsFragmentDoc}
${TaskFilterOptionsFragmentDoc}
${ProjectRoleDetailsFragmentDoc}`;

/**
 * __useScheduleTemplateEditPageQuery__
 *
 * To run a query within a React component, call `useScheduleTemplateEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTemplateEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTemplateEditPageQuery({
 *   variables: {
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *   },
 * });
 */
export function useScheduleTemplateEditPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables> & ({ variables: ScheduleTemplateEditPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>(ScheduleTemplateEditPageDocument, options);
      }
export function useScheduleTemplateEditPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>(ScheduleTemplateEditPageDocument, options);
        }
// @ts-ignore
export function useScheduleTemplateEditPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>;
export function useScheduleTemplateEditPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTemplateEditPageQuery | undefined, ScheduleTemplateEditPageQueryVariables>;
export function useScheduleTemplateEditPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>(ScheduleTemplateEditPageDocument, options);
        }
export type ScheduleTemplateEditPageQueryHookResult = ReturnType<typeof useScheduleTemplateEditPageQuery>;
export type ScheduleTemplateEditPageLazyQueryHookResult = ReturnType<typeof useScheduleTemplateEditPageLazyQuery>;
export type ScheduleTemplateEditPageSuspenseQueryHookResult = ReturnType<typeof useScheduleTemplateEditPageSuspenseQuery>;
export type ScheduleTemplateEditPageQueryResult = ApolloReactCommon.QueryResult<ScheduleTemplateEditPageQuery, ScheduleTemplateEditPageQueryVariables>;
export const SaveScheduleTemplatesDocument = gql`
    mutation SaveScheduleTemplates($scheduleTemplates: SaveScheduleTemplatesInput!) {
  saveScheduleTemplates(input: $scheduleTemplates) {
    scheduleTemplates {
      ...ScheduleTemplatesDetail
    }
    userErrors {
      message
    }
  }
}
    ${ScheduleTemplatesDetailFragmentDoc}`;

/**
 * __useSaveScheduleTemplatesMutation__
 *
 * To run a mutation, you first call `useSaveScheduleTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduleTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduleTemplatesMutation, { data, loading, error }] = useSaveScheduleTemplatesMutation({
 *   variables: {
 *      scheduleTemplates: // value for 'scheduleTemplates'
 *   },
 * });
 */
export function useSaveScheduleTemplatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveScheduleTemplatesMutation, SaveScheduleTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveScheduleTemplatesMutation, SaveScheduleTemplatesMutationVariables>(SaveScheduleTemplatesDocument, options);
      }
export type SaveScheduleTemplatesMutationHookResult = ReturnType<typeof useSaveScheduleTemplatesMutation>;
export type SaveScheduleTemplatesMutationResult = ApolloReactCommon.MutationResult<SaveScheduleTemplatesMutation>;
export const DuplicateScheduleTemplateDocument = gql`
    mutation DuplicateScheduleTemplate($input: DuplicateScheduleTemplateInput!) {
  duplicateScheduleTemplate(input: $input) {
    scheduleTemplate {
      ...ScheduleTemplatesDetail
    }
    userErrors {
      message
    }
  }
}
    ${ScheduleTemplatesDetailFragmentDoc}`;

/**
 * __useDuplicateScheduleTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateScheduleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateScheduleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateScheduleTemplateMutation, { data, loading, error }] = useDuplicateScheduleTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateScheduleTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateScheduleTemplateMutation, DuplicateScheduleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateScheduleTemplateMutation, DuplicateScheduleTemplateMutationVariables>(DuplicateScheduleTemplateDocument, options);
      }
export type DuplicateScheduleTemplateMutationHookResult = ReturnType<typeof useDuplicateScheduleTemplateMutation>;
export type DuplicateScheduleTemplateMutationResult = ApolloReactCommon.MutationResult<DuplicateScheduleTemplateMutation>;